export const rfidFields = [
  {
    label: 'RFID',
    key: 'rfid',
  }
].map((field) => ({
  ...field,
  isSortable: true,
  showErrorKey: field.key,
  thAttr: {
    style: 'min-width:180px;',
  },
}))
